/** Public site origin (no trailing slash). */
export const SITE_ORIGIN = 'https://www.hirayind.com';
